// ─────────────────────────────────────────────────────────────────
// Glass-i — DGU Consumables master helpers (Stage DGU-CONSUMABLE-1).
// Pure UI helpers: kind / pack / uom option lists, per-kind defaults, and the
// pack → stock-unit preview. Kept in lockstep with the backend constants +
// migration 0157 CHECK enums.
// ─────────────────────────────────────────────────────────────────

export const KIND_OPTIONS = [
  { value: 'spacer', label: 'Spacer' },
  { value: 'desiccant', label: 'Desiccant' },
  { value: 'primary_sealant', label: 'Primary sealant' },
  { value: 'secondary_sealant', label: 'Secondary sealant' },
  { value: 'corner_key', label: 'Corner key' }
];

export const PACK_OPTIONS = ['BAR', 'REEL', 'BAG', 'BOX', 'DRUM', 'PAIL'].map((v) => ({ value: v, label: v }));
export const UOM_OPTIONS = ['RMT', 'KGS', 'NOS'].map((v) => ({ value: v, label: v }));

// Sensible per-kind defaults (stock unit + how it's usually bought).
export const DEFAULT_UOM = {
  spacer: 'RMT', desiccant: 'KGS', primary_sealant: 'KGS', secondary_sealant: 'KGS', corner_key: 'NOS'
};
export const DEFAULT_PACK = {
  spacer: 'BAR', desiccant: 'BAG', primary_sealant: 'BOX', secondary_sealant: 'PAIL', corner_key: 'BOX'
};

const KIND_TAG_COLOR = {
  spacer: 'geekblue', desiccant: 'green', primary_sealant: 'gold',
  secondary_sealant: 'volcano', corner_key: 'purple'
};

export const kindLabel = (v) => (KIND_OPTIONS.find((o) => o.value === v) || {}).label || (v ? String(v) : '—');
export const kindColor = (v) => KIND_TAG_COLOR[v] || 'default';

// Stock-units in one pack (= pack_size). Null when not a positive number.
export function unitsPerPack(packSize) {
  const s = Number(packSize);
  return Number.isFinite(s) && s > 0 ? Math.round(s * 1000) / 1000 : null;
}

const NF3 = new Intl.NumberFormat('en-IN', { minimumFractionDigits: 3, maximumFractionDigits: 3 });
export function fmtNum3(v) {
  const n = Number(v);
  return Number.isFinite(n) ? NF3.format(n) : '—';
}
